export default {"src":"/_next/static/media/X.4051d29f.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};